import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import backbutton from './assets/backbutton.png';
import SEO from './components/SEO';
import './css/ContactSupport.css';

function ContactSupport() {
  return (
    <div className="contact-support-container">
      <SEO 
        title="Contact Support - Savory"
        description="Get personalized support for Savory. Contact our team for help with any questions or issues you might have with our recipe platform."
        keywords="contact support, customer service, help, Savory support, technical assistance"
        url="/support"
        type="article"
      />
      
      <div className="back-button-container">
        <Link to="/" className="back-button-details">
          <img src={backbutton} alt="Back" className="backButtonImg" />
        </Link>
      </div>

      <motion.div 
        className="support-content"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <motion.header 
          className="support-header"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <h1>Get personalized support now.</h1>
          <p className="support-subtitle">We're here to help you every step of the way</p>
        </motion.header>

        <motion.div 
          className="support-sections"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <section className="support-section">
            <p className="intro-text">
              We're here to ensure your experience with our app is smooth and enjoyable. If you run into any problems or have any questions, please don't hesitate to reach out to us. Our team is dedicated to providing you with the support you need.
            </p>
          </section>

          <section className="support-section contact-section">
            <h2>Contact Us</h2>
            <p>
              For any support inquiries or feedback, send us an email at <strong>team@savory.ink</strong>. We're committed to responding promptly and helping you resolve any issues you might face.
            </p>
            <div className="contact-action">
              <a href="mailto:team@savory.ink" className="contact-button">
                📧 Send us an email
              </a>
            </div>
          </section>

          <section className="support-section feedback-section">
            <h2>Your Feedback Matters</h2>
            <p>
              Remember, your feedback is invaluable to us, not only for solving immediate concerns but also for improving the app in future updates. We look forward to hearing from you and are here to assist in any way we can.
            </p>
          </section>
        </motion.div>

        <motion.footer 
          className="support-footer"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.6 }}
        >
          <p>Need help with something else?</p>
          <div className="footer-links">
            <Link to="/privacy" className="footer-link">
              Privacy Policy
            </Link>
            <Link to="/terms" className="footer-link">
              Terms of Service
            </Link>
            <Link to="/" className="back-to-home">
              ← Back to Savory
            </Link>
          </div>
        </motion.footer>
      </motion.div>
    </div>
  );
}

export default ContactSupport;